export default __webpack_public_path__ + "static/media/smart-contracts.e3b2be8f.png";